export default __webpack_public_path__ + "static/media/nandish.bc24e17f.jpeg";